const ReducerTypes = {
  auth: 'AUTH',
  admin: 'ADMIN', 
  common: 'COMMON',
  search: 'SEARCH',
  profile: 'PROFILE',
  sidebar: 'SIDEBAR' 
};

export default ReducerTypes
